/*
 * @Author: Teemo Ding
 * @Date: 2022-02-10 17:34:39
 * @LastEditTime: 2022-06-06 16:50:45
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/AuditTrail/Communication/CommunicationList/index.tsx
 */

import { NoDataPage } from '@/src/components';
import Breadcrumb from '@/src/components/Antd/Breadcrumb/Breadcrumb';
import GlobalTable from '@/src/constrains/BulkEditorTable/BulkEditorTable2';
import {
  communicationInit,
  communicationSearch,
} from '@/src/request/auditTrail/communication';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import { useQueries, useSelectRows } from '@/src/tools/hooks/listPageHooks';
import {
  ILogisticsMethod,
  IOrderStatus,
  OrderList as IOrderList,
} from '@/src/types/common/order';
import {
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
  EPermissionSource,
} from '@/src/types/common/resources';
import React, { memo, useState } from 'react';
import ModalHoc from 'src/constrains/ModalHOC';
import ListPageLayout from 'src/layout/ListPageLayout/ListPageLayout';
import { defaultPageSize } from 'src/tools/constant';
import { useAfterDidMountEffect } from 'src/tools/customHooks';
import { randomNumber } from 'src/tools/helper';
import ExportCommunicationRecords from '../Components/ExportCommunicationRecords';
import { breadcrumbData, columns, filterList } from './config';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const customerConvertQuery = (filter) => {
  const {
    salesChannelUuids = [],
    gatewayUuids = [],
    categories = [],
    statuses = [],
  } = filter;
  const re: any = {};
  if (salesChannelUuids && salesChannelUuids.length > 0) {
    re.salesChannelUuids = salesChannelUuids.map((i) => {
      const { value } = i;
      return value;
    });
  }
  if (gatewayUuids && gatewayUuids.length > 0) {
    re.gatewayUuids = gatewayUuids.map((i) => {
      const { value } = i;
      return value;
    });
  }
  if (categories && categories.length > 0) {
    re.categories = categories.map((i) => {
      const { value } = i;
      return value;
    });
  }
  if (statuses && statuses.length > 0) {
    re.statuses = statuses.map((i) => {
      const { value } = i;
      return value;
    });
  }

  //if (customFilterTransfer) customFilterTransfer(filter, re);
  return re;
};
const permissions = () => {
  const view_communication_audit_trail_listing_page = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Communication,
        subCategory: EnumSubCategory.CommunicationAuditTrail,
        operation: EnumOperation.view_communication_audit_trail_listing_page,
      }),
    ],
  });
  const view_communication_audit_trail_details_page = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Communication,
        subCategory: EnumSubCategory.CommunicationAuditTrail,
        operation: EnumOperation.view_communication_audit_trail_details_page,
      }),
    ],
  });

  return {
    view_communication_audit_trail_listing_page,
    view_communication_audit_trail_details_page,
  };
};
const CommunicationList = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    view_communication_audit_trail_listing_page,
    view_communication_audit_trail_details_page,
  } = permissions();
  const {
    modalOp: { setShowModal, setModalTitle, setModalContent },
  } = props;
  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState<IOrderList[]>([]);
  /* 分页 */
  const [current, setCurrent] = useState(0);
  const [total, setTotal] = useState(0);
  const [gatewayList, setGatewayList] = useState('');
  const [salesChannelList, setSalesChannelList] = useState([]);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [reportingCurrency, setReportingCurrency] = useState('');
  const [timezoneInGMT, setTimezoneInGMT] = useState('');
  const [noProducts, setNoProducts] = useState(false);
  const [sortBy, setSortBy] = useState<any>({});
  const [tabsActive, setTabsActive] = useState('');
  //分页配置
  const paginationProps = {
    defaultPageSize: pageSize,
    showQuickJumper: true,
  };

  const { clearSearchState, queryProps, search } = useQueries(
    filterList(salesChannelList, gatewayList, { getI18n }),
    [],
    customerConvertQuery,
  );

  /* 多选 */
  const {
    rowSelection,
    selectedRowKeys,
    setMappedSelectedKeys,
    //mappedSelectedKeys,
    setSelectedRowKeys,
  } = useSelectRows(orders);

  //清除table状态
  const clearTableState = () => {
    setSelectedRowKeys([]);
    setMappedSelectedKeys([]);
  };

  //tab改变事件
  const tabChange = (activeKey) => {
    clearTableState();
    clearSearchState();
    setCurrent(0);
    setTabsActive(activeKey);
  };

  const getProduct = (cb) => {
    if (!loading) {
      setLoading(true);
    }
    const data = search;
    const status = tabsActive
      ? tabsActive == IOrderStatus.SUSPENDED ||
        tabsActive == IOrderStatus.CANCELLED
        ? { orderStatuses: [tabsActive] }
        : { fulfillmentStatuses: [tabsActive] }
      : {};
    const clickCollectIndex = (data.fulfillmentStatuses || []).findIndex(
      (item) => item === ILogisticsMethod.ClickCollect,
    );
    if (clickCollectIndex > -1) {
      data.fulfillmentStatuses.splice(clickCollectIndex, 1);
    }
    const _data = {
      ...data,
      ...status,
      ...(Object.keys(sortBy).length ? { sortBy } : {}),
    };
    communicationSearch(current * pageSize, pageSize, _data).then((res) => {
      const { totalCount } = res;
      setTotal(totalCount);
      const orders: IOrderList[] = res.results.map((i) => {
        return {
          ...i,
          key: randomNumber(),
        };
      });
      setOrders(orders);
      setLoading(false);
    });
  };

  React.useEffect(() => {
    if (view_communication_audit_trail_listing_page) {
      const data = {};
      communicationInit(current * pageSize, pageSize, data).then((res) => {
        const {
          timezoneInGmt = '',
          salesChannels = [],
          gateways = [],
          logList: { totalCount = 0, results = [] } = {},
        } = res;
        setSalesChannelList(salesChannels);
        setReportingCurrency(reportingCurrency);
        setTimezoneInGMT(timezoneInGmt);
        setTotal(totalCount);
        setGatewayList(gateways);
        setOrders(results);
        if (totalCount > 0) {
          setNoProducts(true);
        }
      });
    }
  }, []);

  useAfterDidMountEffect(() => {
    if (view_communication_audit_trail_listing_page) {
      getProduct(() => void 0);
    }
  }, [tabsActive, current]);

  useAfterDidMountEffect(() => {
    if (view_communication_audit_trail_listing_page) {
      if (!current) {
        getProduct(() => void 0);
      } else {
        setCurrent(0);
      }
    }
  }, [pageSize, search, sortBy]);

  const exportFun = () => {
    const currentUuids = orders.map((item) => item.uuid);
    setShowModal(true);
    setModalTitle(
      getI18n('communication.communicationList.exportCommunicationRecords'),
    );
    setModalContent(
      <ExportCommunicationRecords
        selectedRowKeys={selectedRowKeys}
        current={currentUuids}
        onCancel={() => setShowModal(false)}
      />,
    );
  };
  const pageLayoutProps = {
    title: getI18n('communication.communicationList.communication'),
    tabChange,
    exportFun,
    activeKey: tabsActive,
    tabsConfig: [
      //定义tabs列表
      { name: getI18n('general.all'), key: '' },
    ],
  };

  return (
    <React.Fragment>
      <Breadcrumb
        className={css.breadcrumb}
        breadcrumbData={breadcrumbData({ getI18n })}></Breadcrumb>
      {!noProducts ? (
        <NoDataPage
          title={getI18n(
            'communication.communicationList.nocommunicationrecordsyet.',
          )}
          introduce={getI18n(
            'communication.communicationList.thispagewilldisplayallcommunicationrecords.',
          )}
        />
      ) : (
        <ListPageLayout {...pageLayoutProps} tabChange={tabChange}>
          <GlobalTable
            id='communicationList'
            queryProps={queryProps}
            dataSource={orders}
            columns={columns(
              timezoneInGMT,
              reportingCurrency,
              !view_communication_audit_trail_details_page,
              { getI18n },
            )}
            rowKey='uuid'
            hideBulkEditor
            pagination={paginationProps}
            current={current}
            setCurrent={setCurrent}
            pageSize={pageSize}
            setPageSize={setPageSize}
            total={total}
            holdHeader
            bulkEditText={getI18n('communication.communicationList.print')}
            rowSelection={rowSelection}
            selectedRowKeys={selectedRowKeys}
            hidePagination={total == 0}
            // onRow={(record) => ({
            //   onClick: () => history.push(`/communication/${record.uuid}`),
            // })}
            onChange={(_, s, sort) => {
              const ascent = sort.order == 'ascend' ? true : false;
              const field =
                sort.field == 'reportingTotalPrice' ? 'totalPrice' : sort.field;
              setSortBy({ field, ascent });
            }}
            loading={loading}
          />
        </ListPageLayout>
      )}
    </React.Fragment>
  );
};

export default ModalHoc(memo(CommunicationList));
